module.exports = __webpack_public_path__ + "static/Testimonial-d21282ae77a46a35bc8d85dc16e1bf1b.jpg";